import { helper as buildHelper } from '@ember/component/helper'
import { htmlSafe } from '@ember/template'

export function styleBgColor([color]: [string?]) {
  return color ? htmlSafe(`background-color: ${color}`) : ''
}

export default buildHelper(styleBgColor)
